import { datadogRum } from "@datadog/browser-rum";
import { reactPlugin } from "@datadog/browser-rum-react";

let environment = "development";
if (window.location.host === "ops.primary.tech") {
  environment = "production";
} else if (window.location.host === "staging-ops.primary.tech") {
  environment = "staging";
}

datadogRum.init({
  applicationId: import.meta.env.VITE_DATADOG_APPLICATION_ID,
  clientToken: import.meta.env.VITE_DATADOG_CLIENT_TOKEN,
  site: import.meta.env.VITE_DATADOG_SITE,
  service: import.meta.env.VITE_DATADOG_SERVICE,
  env: environment,

  // version: '1.0.0',
  sessionSampleRate: 100,
  sessionReplaySampleRate: 100,
  defaultPrivacyLevel: "mask-user-input",
  plugins: [reactPlugin({ router: false })],
  allowedTracingUrls: [`https://${window.location.host}/`],
});
